import { render, staticRenderFns } from "./TariffsPage.vue?vue&type=template&id=4c822ca2"
import script from "./TariffsPage.vue?vue&type=script&lang=js"
export * from "./TariffsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports